
import { QuestionTypeEnum } from "@/interfaces/QuestionTypeEnum";
import { Question } from "@/interfaces/Question";
import { unsanitize } from "@/utils/htmlUtils";
import Vue from "vue";

export default Vue.extend({
  name: "question-information",
  props: {
    value: Object,
    showerror: Boolean,
    readonly: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      question: null as Question | null,
      questionTypeEnum: QuestionTypeEnum,
    };
  },
  created() {
    this.importData(this.value);
  },
  computed: {
    getHTML() {
      this.question!.selectedAnswers = [
        {
          answerID: 1,
          followUpQuestionID: 0,
          order: 1,
          answerText: "",
          deny: false,
          alertText: "",
          hardStop: false,
          chooseProductID: null,
          requirePhysicianTier: null,
          image: "",
          calculated: false,
        },
      ];
      return unsanitize(this.question!.questionText);
    },
  },
  methods: {
    importData(newVal: Question) {
      this.question = newVal;
    },
  },
});
